import React, { useState } from 'react';

import { notification, Row } from 'antd';
import routePaths, { isChallengeDetail } from 'config/routes';
import { useRouter } from 'next/router';
import { Dispatch } from 'redux';
import { deleteDataCall, postDataCallById } from 'services/api';
import apiPaths from 'services/apiPaths';
import { UpdateUserPoints } from 'src/actions/authActions';

interface IChallengeLike {
  challengeLikes: { totalLikes: number; liked: boolean };
  challengeId: number;
  likedClassName: string;
  dislikedClassName: string;
  updateChallenges?: (liked: boolean) => void;
  updateUserPoints: (
    userPoints: number
  ) => (dispatch: Dispatch<UpdateUserPoints>) => void;
}

export const ChallengeLike = ({
  challengeLikes,
  challengeId,
  likedClassName,
  dislikedClassName,
  updateChallenges,
  updateUserPoints,
}: IChallengeLike) => {
  const [liked, setLiked] = useState(challengeLikes.liked);
  const [totalLikes, setTotalLikes] = useState(challengeLikes.totalLikes);
  const [loading, setLoading] = useState(false);
  const { pathname } = useRouter();

  const handleLikes = async () => {
    let response = null;

    try {
      setLoading(true);
      setLiked(!liked);
      if (!liked) {
        response = await postDataCallById({
          dataPath: apiPaths.CHALLENGES.LIKES,
          id: challengeId,
        });
        setLoading(false);
        if (response.status === 200) {
          const newScore = response.data.score;
          setTotalLikes(totalLikes + 1);
          if (newScore !== undefined && newScore !== null)
            updateUserPoints(newScore);
        }
      } else {
        response = await deleteDataCall({
          dataPath: apiPaths.CHALLENGES.LIKES,
          id: challengeId,
          callConfig: {},
        });
        setLoading(false);

        if (response.status === 200) {
          const newScore = response.data.score;
          setTotalLikes(totalLikes - 1);
          if (newScore !== undefined && newScore !== null)
            updateUserPoints(newScore);
        }
      }

      if (
        updateChallenges &&
        (isChallengeDetail(pathname) ||
          [
            routePaths.PAGES.TALK,
            routePaths.PAGES.TRAINING,
            routePaths.PAGES.CAMPAIGN,
          ].includes(pathname))
      )
        updateChallenges(!liked);
    } catch (err) {
      console.error('~ err', err);

      setLiked(liked);
      setLoading(false);

      console.group(err);
      notification.error({
        message: 'Could not perform like',
      });
    }
  };

  let className = liked ? likedClassName : dislikedClassName;
  if (loading) className += ' disabled';

  return (
    <>
      <Row justify="center" align="middle">
        <a className={className} onClick={handleLikes} />
      </Row>
      <Row justify="center" align="middle" className="show_only_mobile">
        <div className="challengeCard__likes__number">{totalLikes}</div>
      </Row>
    </>
  );
};
